export default function isFeatureEnabled(context, featureName) {
  const featureSet = context.stores.appFeatures.get();
  return featureSet.isEnabled(featureName);
}
